const interviewQuestionItem = [
    ["事業内容",true],
    ["経営理念",true],
    ["求められるスキル",true],
    ["自分が感じたこと",false],
    ["質問したいこと",false]
]
export default interviewQuestionItem;